import React from 'react'
import { Button, Grid, Checkbox, Icon, Message, Modal, Breadcrumb } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import { source } from 'react-aim';
import Labels from '../../../common/Labels';
import TextEditor from '../../../common/TextEditor'
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6
import { singleLineText, urlValidation } from '../../../common/RegexValidation';
import camelCaseCovert from '../../../../helpers/convert-camel-case'
import MomentDate from '../../../common/MomentDate';

let baseCategory;
let category;
let subCategory;
let type;
let isPrivate;
let isAccepted = true;
let contentStatus = 'Accept';
let reviewCheck = false;
let accountLevelAccess = false;
let categoryId;

@source({
    mouseEnter: (props, component) => {
        if (props.match.params.contentId && !props.authorizeContent) {
            dispatch.app.setHelpContext("Edit Content");
        } else if (props.authorizeContent) {
            dispatch.app.setHelpContext("Review Content");
        } else {
            dispatch.app.setHelpContext(props.name);
        }
    }
})

class AddContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            description: '',
            baseCategory: '',
            category: '',
            subCategory: '',
            scope: '',
            status: 'in_development',
            approvedAt:null,
            type: 'Type',
            contentpath: '',
            contentAuthor: '',
            reviewedby: '',
            comments: '',
            otherSubCategory: '',
            otherfield: '',
            isDisabled: true,
            isReviewChecked: false,
            categoryMsgFlag: false,
            isContentTypeEmpty: false,
            isKnowledgeBankEmpty: false,
            isCategoryEmpty: false,
            isSubCategoryEmpty: false,
            addContentError: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangebaseCategory = this.handleChangebaseCategory.bind(this);
        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleChangeSubCategory = this.handleChangeSubCategory.bind(this);
        this.handleChangeType = this.handleChangeType.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeAuthor = this.handleChangeAuthor.bind(this);
        this.handleChangeReviewer = this.handleChangeReviewer.bind(this);
        this.handleAuthorization = this.handleAuthorization.bind(this);
        this.reviewOptional = this.reviewOptional.bind(this);
        this.setAccountLevelAccess = this.setAccountLevelAccess.bind(this);
        this.publishContent = this.publishContent.bind(this);
        this.setsubCategory = this.setsubCategory.bind(this);
        this.checkIsValid = this.checkIsValid.bind(this);
        this.getReviewersRole = this.getReviewersRole.bind(this)
        this.updateText = this.updateText.bind(this);
        this.handleComment = this.handleComment.bind(this);
    }

    setsubCategory() {
        dispatch.content.setSubCategoryAsync(category.subCategories);
        // below changes made for KLM-8874
        this.setState({ subCategory: null, otherSubCategory: null })
    }

    setDefault(bcArr) {
        if (!bcArr || bcArr.length === 0) return;
        const f1 = bcArr.find(f => f.default);
        if (!f1) return;
        baseCategory = f1;
        this.setState({ basecategoryid: f1._id, baseCategory: f1._id });
        dispatch.content.setCategoryAsync(f1.nodes);

        const f2 = f1.nodes && f1.nodes.find(f => f.default);
        if (!f2) return;
        category = f2;
        this.setState({ categoryid: f2._id, category: f2._id });
        dispatch.content.setSubCategoryAsync(f2.nodes);

        const f3 = f2.nodes && f2.nodes.find(f => f.default);
        if (!f3) return;
        subCategory = f3._id;
        this.setState({ subCategory: f3._id });
    }

    reviewOptional(data) {
        reviewCheck = !reviewCheck;
        this.setState({ reviewedby: '' })
    }

    setAccountLevelAccess(data) {
        accountLevelAccess = !accountLevelAccess;
        this.setState({ accountLevelAccess })
    }

    async publishContent() {
        dispatch.content.setCancelFlag(true);
        let slug = this.state.name.toLowerCase().trim();
        if (!(singleLineText.test(this.state.name))) {
            toastr.error('Message', 'Enter valid Content Name.');
            return;
        }
        // if (this.props.match.params.contentId && !this.props.authorizeContent) {
            if(!this.state.type || this.state.type === 'Type'){
                    this.setState({
                        isContentTypeEmpty: true
                    })
                return;    
            }
            if (!this.state.contentpath) {
                toastr.error('Message', 'Content URL is required.')
                return;
            }
            if (/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/.test(this.state.contentpath)) {
                this.setState({ "isDisabled": false });
            }
            else {
                toastr.error('Message', 'Enter valid Content URL')
                return;
            }
            if (!this.state.baseCategory || this.state.baseCategory === 'Select Knowledge Bank') {
                this.setState({
                    isKnowledgeBankEmpty: true
                })
                return;
            }
            if (!this.state.category || this.state.category === 'Select Category'||this.state.category==="select") {
                this.setState({
                    isCategoryEmpty: true
                })
                return;
            }
            if (!this.state.subCategory || this.state.subCategory === 'Select Sub Category'||this.state.subCategory==="select") {
                this.setState({
                    isSubCategoryEmpty: true
                })
                return;
            }
        // }
        let message = <div className="confirmMessage">
            <h3>Publish Content</h3>
            {/* <label>{this.props.selectedPracticeLibrary.name} {this.props.practiceLabelName}</label> */}
            <p>Are you sure that you wish to do this?</p>
        </div>

        toastr.confirm(message, {
            onOk: async () => {
        try {
            if (this.props.match.params.contentId && !this.props.authorizeContent) {

                let editContents = Object.assign({}, this.state);
                editContents.id = this.props.editContent._id;
                if (!editContents.subCategory || editContents.subCategory === 'Select Sub Category' || editContents.subCategory === 'others') {
                    this.setState({
                        isSubCategoryEmpty: true
                    })
                    return;
                }
                if (!(singleLineText.test(editContents.subCategory))) {
                    toastr.error('Message', 'Enter valid Sub-Category.');
                    return;
                }
                delete editContents.basecategoryid;
                delete editContents.categoryid;
                delete editContents.status;
                delete editContents.reviewedby;
                editContents.status = 'published';
                editContents.fullName = this.props.user.firstName + ' ' + this.props.user.lastName;
                editContents.slug = slug;
                let userid = this.props.user._id.toString();

                editContents.organizationId = this.props.selectedOrganisation.id;
                editContents.userid = userid;
                editContents.accountLevelAccess = accountLevelAccess;
                editContents.organizationId = this.props.match.params.workspaceId;
                editContents.accountId = this.props.match.params.accountId;
                editContents.currentContentStatus = this.props.match.params.status;
                editContents.approvedAt=this.props.editContent.approvedAt
                await dispatch.content.updateContents(editContents);
                await dispatch.content.showAddContentBreadCrum(false);

            }
            else {
                delete this.state.status;
                this.setState({ 'status': 'published' })
                let publishContents = Object.assign({}, this.state);
                delete publishContents.status;
                delete publishContents.reviewedby;
                publishContents.status = 'published'
                publishContents.baseCategory = baseCategory._id;
                publishContents.category = category._id;

                publishContents.subCategory = subCategory;
                publishContents.type = type;
                publishContents.scope = isPrivate ? 'Private' : 'Public'
                publishContents.author = this.props.user._id;
                publishContents.fullName = this.props.user.firstName + ' ' + this.props.user.lastName;
                publishContents.slug = slug;
                publishContents.accountLevelAccess = accountLevelAccess;
                publishContents.accountId = this.props.match.params.accountId;
                publishContents.description = this.state.description;
                // publishContents.summary = this.state.description;
                publishContents.organizationId = this.props.match.params.workspaceId;
                publishContents.subCategory = (publishContents.subCategory === 'others') || (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length === 0) ? this.state.otherfield : (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length > 0) ? subCategory : null
                await dispatch.content.addNewContent(publishContents);
                await dispatch.content.showAddContentBreadCrum(false);

            }
            reviewCheck = false;
        }
        catch (err) {
            this.setState({ addContentError: err })
        }
    }})
    }

    handleChange(event) {
        const target = event.target;
        let value;

        const name = target.name;
        if (name === 'contentpath') {
            value = target.value.replace(' ', '%20');

            if (/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/.test(this.state.contentpath)) {
                this.setState({ "isDisabled": false });
            }
            else {
                this.setState({ "isDisabled": true });
            }
        }
        else {
            value = target.value.trim();
        }

        this.setState({
            [name]: value
        });
        this.checkIsValid();

    }

    checkIsValid() {
        if (this.state.name && this.state.type && this.state.contentpath && this.state.baseCategory && this.state.category) {
            if (/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.%]+$/.test(this.state.contentpath)) {
                this.setState({ "isDisabled": false });
            }
            else {
                this.setState({ "isDisabled": true });
            }
        }
        else {
            this.setState({ "isDisabled": true });
        }
    }

    handleChangeAuthor(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value.trim()
        });
    }

    handleCancel() {
        dispatch.lifeCycle.activePage('');
        dispatch.content.setCancelFlag(true);
        const history = this.props.history;
        history.push({
            pathname: this.props.contentPath ? `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/${this.props.contentPath.split('_ct/')[1]}` : `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct`
        });
        
        isPrivate = true;
        dispatch.content.showAddContentBreadCrum(false);

        let userid = this.props.user._id.toString();
        let payload = {};
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.userid = userid;

        isPrivate = true;
        accountLevelAccess = false;
        isAccepted = true;
        contentStatus = 'Accept';
        reviewCheck = false;
    }

    async handleSubmit(contentData) {
        dispatch.content.setCancelFlag(true);
        dispatch.lifeCycle.activePage('');

        try {
            let slug = this.state.name.toLowerCase().trim();

            if (this.props.match.params.contentId && !this.props.authorizeContent) {
                if (!this.state.baseCategory || this.state.baseCategory === 'Select Knowledge Bank') {
                    this.setState({
                        isKnowledgeBankEmpty: true
                    })
                    return;
                }
                // Below changes made for KLM-8881
                if (!this.state.category || this.state.category === 'Select Category' || this.state.categoryid === "select") {
                    this.setState({
                        isCategoryEmpty: true
                    })
                    return;
                }

                if (!this.state.type || this.state.type === 'Type') {
                    this.setState({
                        isContentTypeEmpty: true
                    })
                    return;
                }
                if (!this.state.reviewedby && this.props.editContent.reviewedbyObj) {
                    toastr.error('Message', 'Reviewer is required.')
                    return;
                }


                let editContents = Object.assign({}, this.state);
                editContents.id = this.props.editContent._id;
                delete editContents.basecategoryid;
                delete editContents.categoryid;
                delete editContents.status;
                if (!editContents.subCategory || editContents.subCategory === 'Select Sub Category' || editContents.subCategory === 'others') {
                    this.setState({
                        isSubCategoryEmpty: true
                    })
                    return;
                }

                if (this.state.status) {
                    editContents.status = 'under_review'
                }
                if (!editContents.reviewedby || !this.state.reviewedby) {
                    delete editContents.reviewedby;
                    editContents.status = 'in_development'
                }
                editContents.fullName = this.props.user.firstName + ' ' + this.props.user.lastName;
                editContents.slug = slug;

                let userid = this.props.user._id.toString();

                editContents.organizationId = this.props.selectedOrganisation.id;
                editContents.userid = userid;
                editContents.organizationId = this.props.match.params.workspaceId;
                editContents.accountId = this.props.match.params.accountId;
                editContents.currentContentStatus = this.props.match.params.status;
                await dispatch.content.updateContents(editContents);
                await dispatch.content.showAddContentBreadCrum(false);
            } else if (this.props.authorizeContent) {
                if (!this.state.baseCategory || this.state.baseCategory === 'Select Knowledge Bank') {
                    this.setState({
                        isKnowledgeBankEmpty: true
                    })
                    return;
                }
                // Below changes made for KLM-8881
                if (!this.state.category || this.state.category === 'Select Category' || this.state.categoryid === "select") {
                    this.setState({
                        isCategoryEmpty: true
                    })
                    return;
                }

                if (!this.state.type || this.state.type === 'Type') {
                    this.setState({
                        isContentTypeEmpty: true
                    })
                    return;
                }
                if (!isAccepted && !this.state.comments) {
                    toastr.error('Message', 'Comment is required.')
                    return;
                }
                let authorizeContents = Object.assign({}, this.state);
                authorizeContents.id = this.props.editContent._id;
                delete authorizeContents.basecategoryid;
                delete authorizeContents.categoryid;
                delete authorizeContents.status;
                authorizeContents.status = 'published'
                authorizeContents.reviewedby = this.props.user._id
                if (this.state.status === 'Reject') {
                    authorizeContents.status = 'rejected'
                }
                else {
                    authorizeContents.status = 'published'
                    delete authorizeContents.comments;
                }
                authorizeContents.subCategory = (authorizeContents.subCategory === 'others') || (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length === 0) ? this.state.otherfield : (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length > 0 && !this.state.otherfield) ? subCategory : subCategory

                authorizeContents.slug = slug;

                let userid = this.props.user._id.toString();

                authorizeContents.organizationId = this.props.selectedOrganisation.id;
                authorizeContents.userid = userid;
                authorizeContents.organizationId = this.props.match.params.workspaceId;
                authorizeContents.accountId = this.props.match.params.accountId;
                authorizeContents.currentContentStatus = this.props.match.params.status;

                await dispatch.content.updateContents(authorizeContents);
                await dispatch.content.showAddContentBreadCrum(false);
                isAccepted = true;
                contentStatus = 'Accept';
                this.setState({ 'comments': '' });

            } else {
                contentData.subCategory = (contentData.subCategory === 'others') || (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length === 0) ? this.state.otherfield : (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length > 0) ? this.state.subCategory ? this.state.subCategory : subCategory : null

                if (!this.state.baseCategory || this.state.baseCategory === 'Select Knowledge Bank' ||
                    !this.state.category || this.state.category === 'Select Category' ||
                    !contentData.subCategory || contentData.subCategory === 'Select Sub Category' ||
                    !this.state.type || this.state.type === 'Type') {
                    if (!this.state.baseCategory || this.state.baseCategory === 'Select Knowledge Bank') {
                        this.setState({
                            isKnowledgeBankEmpty: true
                        })
                    }
                    // Below changes made for KLM-8881
                    if (!this.state.category || this.state.category === 'Select Category' || this.state.categoryid === "select") {
                        this.setState({
                            isCategoryEmpty: true
                        })
                    }
                    // Below changes made for KLM-8881
                    if (!subCategory || subCategory === 'Select Sub Category' || this.state.subCategory === "" || this.state.subCategory === "Select Sub Category") {
                        this.setState({
                            isSubCategoryEmpty: true
                        })
                    }
                    if (!this.state.type || this.state.type === 'Type') {
                        this.setState({
                            isContentTypeEmpty: true
                        })
                    }
                    return;
                }
                if (subCategory === 'others' && !this.state.otherfield) {
                    this.setState({
                        isSubCategoryEmpty: true
                    })
                    return;
                }

                contentData.baseCategory = baseCategory._id;
                contentData.category = category._id;
                contentData.subCategory = subCategory;
                contentData.type = type;
                contentData.scope = isPrivate ? 'Private' : 'Public'
                contentData.author = this.props.user._id;
                contentData.fullName = this.props.user.firstName + ' ' + this.props.user.lastName;
                contentData.description = this.state.description;

                contentData.status = this.state.status;
                contentData.slug = slug;
                contentData.organizationId = this.props.match.params.workspaceId;
                // contentData.summary = this.state.description;
                contentData.accountId = this.props.match.params.accountId;
                if (contentData.subCategory === 'others') {
                    contentData.subCategory = this.state.otherfield;
                }
                await dispatch.content.addNewContent(contentData);
                await dispatch.content.showAddContentBreadCrum(false);

            }
        }
        catch (err) {

            this.setState({ addContentError: err })
            throw err;
        }
    }

    async componentDidMount() {
        dispatch.lifeCycle.activePage('createContent');
        this.setState({ addContentError: '' })
        if (this.props.match.params.contentId) {
            let payload = {}
            payload.contentId = this.props.match.params.contentId;
            await dispatch.content.getSpecificContent(payload)

        }

        await dispatch.content.getReviewers(this.props.selectedOrganisation.id)

        reviewCheck = false;
        accountLevelAccess = false;
        if (this.props.match.params.contentId && this.props.editContent) {
            if (this.props.editContent && this.props.editContent.status === "under_review") {
                dispatch.content.authorizeBreadcrum(true);
            }
            let contentsToEdit = this.props.editContent;
            isPrivate = contentsToEdit.scope === 'Private' ? true : false
            this.setState({ "scope": contentsToEdit.scope });
            this.setState({ "name": contentsToEdit.name });
            this.setState({ "description": contentsToEdit.description });
            this.setState({ "accountLevelAccess": contentsToEdit.accountLevelAccess });
            this.setState({ "contentpath": contentsToEdit.contentpath });
            this.setState({ "contentAuthor": contentsToEdit.contentAuthor });
            this.setState({ "baseCategory": contentsToEdit.baseCategory });
            this.setState({ "category": contentsToEdit.category });
            this.setState({ "subCategory": contentsToEdit.subCategory });
            if (contentsToEdit.reviewedbyObj) {
                this.setState({ "reviewedby": contentsToEdit.reviewedbyObj._id });
                this.setState({ "status": 'under_review' });
            }
            category = contentsToEdit.category;

            subCategory = contentsToEdit.subCategory;
            this.setState({ "type": contentsToEdit.type });
            isPrivate = false;
            if (contentsToEdit.scope === "Private") {
                isPrivate = true;
            }
            if (contentsToEdit.status === 'rejected') {
                reviewCheck = true;
            }
            // this.setState({ 'otherSubCategory': 'others' })
            this.setState({ 'otherfield': contentsToEdit.subCategory });
            let baseCategoryList = isPrivate ? this.props.categoryList : this.props.publicCategoryList;
            if (baseCategoryList) {
                for (let i = 0; i < baseCategoryList.length; i++) {
                    if (baseCategoryList[i] && baseCategoryList[i]._id && contentsToEdit && contentsToEdit.baseCategory && baseCategoryList[i]._id.toString() === contentsToEdit.baseCategory.toString()) {
                        this.setState({ "basecategoryid": baseCategoryList[i]._id, baseCategoryName: baseCategoryList[i].name });
                        let categories = baseCategoryList[i].nodes
                        dispatch.content.setCategoryAsync(categories);
                        for (let j = 0; j < categories.length; j++) {
                            let categoryData = categories[j];
                            if (categoryData._id.toString() === contentsToEdit.category.toString()) {
                                this.setState({ "categoryid": categoryData._id, categoryName: categoryData.name });
                                dispatch.content.setSubCategoryAsync(categoryData.nodes);
                                if (categoryData.nodes && categoryData.nodes.length > 0) {
                                    for (let k = 0; k < categoryData.nodes.length; k++) {
                                        if (categoryData.nodes[k] && categoryData.nodes[k]._id && contentsToEdit &&
                                            categoryData.nodes[k]._id.toString() === contentsToEdit.subCategory.toString()) {
                                            this.setState({ subCategoryName: categoryData.nodes[k].name });
                                            break;
                                        }
                                    }
                                }
                                break;
                            }
                        }
                        break;
                    }
                }
            }

        } else {
            baseCategory = null;
            category = null;
            subCategory = null;
            isPrivate = true;
            dispatch.content.setCategoryAsync([]);
            dispatch.content.setSubCategory([]);
            isPrivate = this.props.selectedContentScope === 'Public' && this.props.selectedAccount.publicAccess ? false : true;
            let baseCategoryList = isPrivate ? this.props.categoryList : this.props.publicCategoryList;
            if (baseCategoryList) {
                for (let i = 0; i < baseCategoryList.length; i++) {
                    if (baseCategoryList[i]._id.toString() === this.props.selectedBaseCategory.toString()) {
                        baseCategory = baseCategoryList[i];
                        this.setState({ "basecategoryid": this.props.selectedBaseCategory, baseCategory: baseCategoryList[i].name });
                        let categories = baseCategoryList[i].nodes
                        dispatch.content.setCategoryAsync(categories);
                        for (let i = 0; i < categories.length; i++) {
                            let categoryData = categories[i];
                            if (categoryData._id.toString() === this.props.selectedCategory.toString()) {
                                category = categoryData;
                                this.setState({ "categoryid": this.props.selectedCategory, category: categoryData.name });
                                dispatch.content.setSubCategoryAsync(categoryData.nodes);
                                break;
                            }
                        }
                        break;
                    }
                }
            }
            if (!baseCategory) {
                this.setDefault(baseCategoryList);
            }
            // Below changes made for KLM-8873
            if (this.props.selectedSubCategory.toLowerCase() !== 'others') {
                subCategory = this.props.selectedSubCategory;
                // this.setState({
                //     subCategory: this.props.selectedSubCategory
                // })
            }
            else {
                subCategory = ''
                this.setState({
                    otherSubCategory: 'others'
                })
            }
            this.setState({ scope: this.props.selectedContentScope })

        }
        this.checkIsValid();

    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.match.params.contentId && !baseCategory) {
            const nextList = isPrivate ? nextProps.categoryList : nextProps.publicCategoryList;
            const currList = isPrivate ? this.props.categoryList : this.props.publicCategoryList;
            if (nextList !== currList) {
                this.setDefault(nextList);
            }
        }
        if (this.props.match.params.contentId !== nextProps.match.params.contentId) {
            this.setState({
                name: '',
                description: '',
                baseCategory: '',
                category: '',
                subCategory: '',
                scope: '',
                status: 'in_development',
                type: 'Type',
                contentpath: '',
                contentAuthor: '',
                reviewedby: '',
                comments: '',
                otherSubCategory: '',
                otherfield: '',
                isDisabled: true,
                isReviewChecked: false,
                accountLevelAccess: false
            })


        }
    }

    handleChangebaseCategory(data) {
        dispatch.content.setCategoryAsync([]);
        dispatch.content.setSubCategory([]);
        let baseCategoryId = data.target.value;


        this.setState({ "category": 'Select Category' });
        // Below changes maed for KLM-8873
        this.setState({ "subCategory": "", otherSubCategory: '' });

        if (baseCategoryId === 'select') {
            this.setState({ "baseCategory": 'Select Knowledge Bank' });
            this.setState({ "basecategoryid": 'select' });
        }
        if (isPrivate) {
            for (let i = 0; i < this.props.categoryList.length; i++) {
                let categoryData = this.props.categoryList[i];
                if (baseCategoryId.toString() === categoryData._id.toString()) {
                    baseCategory = categoryData;
                    break;
                }
            }
        }
        else {
            for (let i = 0; i < this.props.publicCategoryList.length; i++) {
                let categoryData = this.props.publicCategoryList[i];
                if (baseCategoryId.toString() === categoryData._id.toString()) {
                    baseCategory = categoryData;
                    break;
                }
            }
        }

        if (baseCategoryId === 'select') {
            this.setState({ isKnowledgeBankEmpty: true })}
        if (baseCategoryId !== 'select') {

            this.setState({ isKnowledgeBankEmpty: false })
            if (baseCategory) {
                if (baseCategory.children && baseCategory.children.length === 0) {
                    this.setState({ categoryMsgFlag: true })
                }
                else {
                    this.setState({ categoryMsgFlag: false })
                    dispatch.content.setCategoryAsync(baseCategory.nodes);
                }
                // Below changes made for KLM-8873
                this.setState({
                    baseCategory: baseCategory._id, category: 'select',
                    basecategoryid: baseCategory._id,
                    categoryid: 'select',
                    subCategory: "",
                });
                dispatch.app.setSelectedBaseCategory(baseCategory._id);
                if (this.props.editContent) {
                    this.props.editContent.category = 'select';
                    this.props.editContent.subCategory = "Select Sub Category";
                }

            }
        }
        if (baseCategoryId === 'select') {
            this.setState({ categoryMsgFlag: false })
            dispatch.content.setCategoryAsync([]);
        }
        this.checkIsValid();
    }

    handleChangeCategory(data) {
        let categoryId = data.target.value;

        this.setState({ "subCategory": "", otherSubCategory: '' });

        this.setState({ "categoryid": categoryId });
        dispatch.app.setSelectedCategory(categoryId);
        if (categoryId === 'select') {
            this.setState({ "category": 'Select Category' });
        }

        for (let i = 0; i < this.props.categoriesArr.length; i++) {
            let categoryData = this.props.categoriesArr[i];
            if (categoryId === categoryData._id) {
                category = categoryData;
                break;
            }
        }
        if (categoryId === 'select'||this.state.category==="Select Category"||this.state.category==="select") {
            this.setState({ isCategoryEmpty: true })
        }

        if (categoryId !== 'select') {
            this.setState({ isCategoryEmpty: false })

            if (category) {
                dispatch.content.setSubCategoryAsync(category.nodes);
                // Below changes made for KLM-8873
                this.setState({
                    "category": category._id,
                    // subCategory: "",
                });

                if (this.props.editContent)
                    this.props.editContent.subCategory = "Select Sub Category";
            }

        }

        if (categoryId === 'select') {
            dispatch.content.setSubCategoryAsync([]);
        }
        this.checkIsValid();
    }

    handleInputChange(data) {

        isPrivate = !isPrivate;
        let scopeName = isPrivate ? 'Private' : 'Public'
        dispatch.content.setCategoryAsync([]);
        dispatch.content.setSubCategory([]);
        dispatch.app.setSelectedContentScope(scopeName);
        this.setState({
            scope: scopeName,
            baseCategory: 'Select Knowledge Bank',
            category: 'select',
            categoryid: 'select',
            subCategory: "Select Sub Category",
            basecategoryid: 'select'
        });
        this.forceUpdate();
    }

    handleAuthorization(data) {
        isAccepted = !isAccepted;
        let contentStatus = isAccepted ? 'Accept' : 'Reject'
        this.setState({
            "status": contentStatus
        });
        this.forceUpdate();
        if (contentStatus === 'Accept') {
            this.setState({ 'comments': '' });
        }
    }

    handleChangeSubCategory(data) {
        // Below changes made for KLM-8881
        if(data.target.value==="" ||data.target.value === "select" || data.target.value === "Select Sub Category") {
            this.setState({isSubCategoryEmpty: true})
        }else if(data.target.value !== "select" || data.target.value !== "Select Sub Category") {
            this.setState({isSubCategoryEmpty: false})
        }
        subCategory = data.target.value;
        this.setState({
            "subCategory": subCategory
        });
        if (this.props.editContent && this.props.editContent.subCategory && subCategory === 'others') {
            delete this.props.editContent.subCategory;
        }
        dispatch.app.setSelectedSubCategory(subCategory);
        this.setState({ otherSubCategory: data.target.value })
        this.checkIsValid();
    }



    handleChangeType(data) {
        type = data.target.value;
        if(type === "Type"){
            this.setState({
                isContentTypeEmpty: true
            })
        }else if(type){
            this.setState({
                isContentTypeEmpty: false
            })
        }
        const name = data.target.name;
        if (type !== 'Type') {
            this.setState({
                [name]: type
            });
        }
        else {
            type = null;
            this.setState({
                [name]: 'Type'
            });
        }
        this.checkIsValid();
    }

    handleChangeReviewer(data) {
        if (data.target.value) {
            this.setState({
                "reviewedby": data.target.value
            });
        }
        else if (data.target.value === '') {
            this.setState({
                "reviewedby": ''
            });
        }
        else {
            this.setState({
                "reviewedby": ''
            });
        }
    }

    async submitforreview(data) {
        try {
            let slug = this.state.name.toLowerCase().trim();
            let contentData = Object.assign({}, this.state);
            if (this.props.editContentPage && !this.props.authorizeContent) {
                if (!(singleLineText.test(this.state.name))) {
                    toastr.error('Message', 'Enter valid Content Name.');
                    return;
                }
                if (!this.state.baseCategory || this.state.baseCategory === 'Select Knowledge Bank') {
                    toastr.error('Message', 'Knowledge bank is required.');
                    return;
                }
                if (!this.state.category || this.state.category === 'Select Category') {
                    toastr.error('Message', 'Category is required.')
                    return;
                }

                if (!this.state.type || this.state.type === 'Type') {
                    toastr.error('Message', 'Content type is required.')
                    return;
                }
                if (!this.state.reviewedby && this.props.editContent.reviewedbyObj) {
                    toastr.error('Message', 'Reviewer is required.')
                    return;
                }


                let editContents = Object.assign({}, this.state);
                editContents.id = this.props.editContent._id;
                delete editContents.basecategoryid;
                delete editContents.categoryid;
                delete editContents.status;
                editContents.subCategory = (editContents.subCategory === 'others') || (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length === 0) ? this.state.otherfield : (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length > 0) ? subCategory : null
                if (!editContents.subCategory || editContents.subCategory === 'Select Sub Category') {
                    toastr.error('Message', 'Sub category is required.')
                    return;
                }
                if (!(singleLineText.test(editContents.subCategory))) {
                    toastr.error('Message', 'Enter valid Sub-Category.');
                    return;
                }

                if (this.state.status) {
                    editContents.status = 'under_review'
                }
                if (!editContents.reviewedby || !this.state.reviewedby) {
                    delete editContents.reviewedby;
                    editContents.status = 'in_development'
                }
                editContents.fullName = this.props.user.firstName + ' ' + this.props.user.lastName;
                editContents.slug = slug;

                let userid = this.props.user._id.toString();

                editContents.accountId = this.props.match.params.accountId;
                editContents.organizationId = this.props.match.params.workspaceId;
                editContents.userid = userid;
                editContents.currentContentStatus = this.props.match.params.status;
                await dispatch.content.updateContents(editContents);
                await dispatch.content.showAddContentBreadCrum(false);
            }
            else {
                contentData.subCategory = (contentData.subCategory === 'others') || (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length === 0) ? this.state.otherfield : (this.props.categoriesArr.length > 0 && this.props.subCategoriesArr.length > 0) ? subCategory : null
                if (!(singleLineText.test(this.state.name))) {
                    toastr.error('Message', 'Enter valid Content Name.');
                    return;
                }
                if (!this.state.baseCategory || this.state.baseCategory === 'Select Knowledge Bank') {
                    toastr.error('Message', 'Knowledge bank is required.');
                    return;
                }
                if (!this.state.category || this.state.category === 'Select Category') {
                    toastr.error('Message', 'Category is required.')
                    return;
                }
                if (!contentData.subCategory || contentData.subCategory === 'Select Sub Category') {
                    toastr.error('Message', 'Sub category is required.')
                    return;
                }
                if (!(singleLineText.test(contentData.subCategory))) {
                    toastr.error('Message', 'Enter valid Sub-Category.');
                    return;
                }
                if (!this.state.type || this.state.type === 'Type') {
                    toastr.error('Message', 'Content type is required.')
                    return;
                }
                if (!this.state.contentpath) {
                    toastr.error('Message', 'Content URL is required.')
                    return;
                }
                contentData.baseCategory = baseCategory._id;
                contentData.category = category._id;
                contentData.subCategory = subCategory;
                contentData.type = type;
                contentData.scope = isPrivate ? 'Private' : 'Public'
                contentData.author = this.props.user._id;
                contentData.fullName = this.props.user.firstName + ' ' + this.props.user.lastName;

                contentData.status = 'under_review';
                contentData.slug = slug;
                contentData.organizationId = this.props.match.params.workspaceId;
                contentData.accountId = this.props.match.params.accountId;
                if (contentData.subCategory === 'others') {
                    contentData.subCategory = this.state.otherfield;
                }
                await dispatch.content.addNewContent(contentData);
                await dispatch.content.showAddContentBreadCrum(false);
            }
        }
        catch (err) {
            this.setState({ addContentError: err })
        }
    }

    getReviewersRole(user) {

        let userObj = user.organizations.filter((org) => {
            return org.id === this.props.selectedOrganisation.id
        })
        return userObj[0].role;
    }

    updateText(data, name) {
        if (name === "Description") {
            this.setState({ description: data })
        }
    }

    handleComment(data, name) {
        const textWithoutTags = data.replace(/<[^>]+>/g, '').trim();
        const hasNonSpaceCharacters = textWithoutTags.replace(/\s/g, '').length > 0;
        if (hasNonSpaceCharacters) {
            this.setState({ comments: data });
        } else {
            this.setState({ comments: '' });
        }
    }
    throwOut = () => {
        this.props.editContent.throwOut = false;
        const history = this.props.history;
        history.push({
            pathname: this.props.contentPath ? `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/${this.props.contentPath.split('_ct/')[1]}` : `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct`
        });
    }
    checkIndex(arr, element) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i]._id === element) {
                return i;
            }
        }
        return -1;
    }
     approve = (event) => {
        
        event.preventDefault()
        let message = <div className="confirmMessage">
            <h3>Approve Content</h3>
            {/* <label>{this.props.selectedPracticeLibrary.name} {this.props.practiceLabelName}</label> */}
            <p>Are you sure that you wish to approve?</p>
        </div>

        toastr.confirm(message, {
            onOk: async () => {
                const { history } = this.props;
                    if (this.props.user._id === this.props.editContent.accountUserId) {
                        contentStatus="Accept"
                        this.setState({
                            "status": contentStatus,
                        
                        });
                    }
                    try{
                        let slug = this.state.name.toLowerCase().trim();    
                        let editContents = Object.assign({}, this.state);
                        
                        editContents.id = this.props.editContent._id;
                        delete editContents.basecategoryid;
                        delete editContents.categoryid;
                        editContents.status="approved";
                        
                        editContents.reviewedby=this.props.user._id
                    if (!editContents.subCategory || editContents.subCategory === 'Select Sub Category' || editContents.subCategory === 'others') {
                        this.setState({
                          isSubCategoryEmpty: true
                       })
                    return;
                }
        editContents.fullName = this.props.user.firstName + ' ' + this.props.user.lastName;
        editContents.slug = slug;

        let userid = this.props.user._id.toString();

        editContents.organizationId = this.props.selectedOrganisation.id;
        editContents.userid = userid;
        editContents.organizationId = this.props.match.params.workspaceId;
        editContents.accountId = this.props.match.params.accountId;
        editContents.currentContentStatus = this.props.match.params.status;
        editContents.approvedAt =new Date().toISOString()
        await dispatch.content.updateContents(editContents);
        await dispatch.content.showAddContentBreadCrum(false);
        history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_ct/status/under_review`);
        
       }catch(err){
        this.setState({ addContentError: err })
     }
    }
        });
    }
    render() {
        const errorLabel = <div className="customErrorLabel" />;
        let contentStatus = this.props.editContent && this.props.editContent.status
        var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });
        if (!this.props.selectedAccount.publicAccess && !contentStatus) {
            isPrivate = true;
        }
        let bcA
        if (isPrivate) {
            bcA = this.props.categoryList && this.props.categoryList.length !== 0 ?
                this.props.categoryList.sort((a, b) => {
                    return collator.compare(a.name, b.name)
                }) : null
        }
        else {
            bcA = this.props.publicCategoryList && this.props.publicCategoryList.length !== 0 ?
                this.props.publicCategoryList.sort((a, b) => {
                    return collator.compare(a.name, b.name)
                }) : null
        }
        let cA = this.props.categoriesArr && this.props.categoriesArr.length !== 0 ?
            this.props.categoriesArr.sort((a, b) => {
                return collator.compare(a.name, b.name)
            }) : null

        let scA = this.props.subCategoriesArr && this.props.subCategoriesArr.length !== 0 ?
            this.props.subCategoriesArr.sort((a, b) => {
                return collator.compare(a.name, b.name)
            }) : null

        let breadCrumb = <Breadcrumb className="breadCrumbs" >
            <Breadcrumb.Section>
                <span className="primary">
                    {this.props.match.params.contentId ? "Edit Content" : "Create Content"}
                </span>
            </Breadcrumb.Section>
        </Breadcrumb>;
        let reviewerName = "";
        if (contentStatus === "rejected") {
            reviewerName = (reviewer => (reviewer ? `${reviewer.accountUserId.firstName} ${reviewer.accountUserId.lastName}` : ""))(this.props.reviewerList.find(user => user.accountUserId._id === this.props.editContent.reviewedby));
        }
        return (
            <div className="pad_20 overflow-auto h_100">
                {breadCrumb}
                <div >
                    <Form noValidate
                        id='addcontentForm'
                        onValidSubmit={(data) => this.handleSubmit(data)}
                        className="formcyForm"
                    >
                        <Grid>
                        {
                          contentStatus === "approved" ? (
                          <Grid.Row className="createPack" style={{pointerEvents: contentStatus === 'approved' ? 'none' : 'auto'}}>
                           <Grid.Column width={11}>
                            <Icon
                            style={{ fontSize: "8px", margin: "0 5px 0 0" }}
                            circular
                            className={contentStatus !== "approved"? "bg-orange" : "bg-green"}
                            name={contentStatus !== "approved"? "close" : "checkmark"}
                    
                            />
               
                            <span 
                               className={contentStatus === "approved" ? "clr-green" : "clr-orange"}
                            >
                             {contentStatus !== "approved" ? "Rejected" : "Approved"}
                            </span>
                             &nbsp;&nbsp;&nbsp;
                              on <strong> 
                               <MomentDate date={this.props.editContent.approvedAt}  /> 
                            </strong>
                             &nbsp;&nbsp;&nbsp;
                              by {" "}
                            <strong>{   
                            this.props.reviewerList.find(user => user.accountUserId._id === this.props.editContent.reviewedby)
                            ? this.props.reviewerList.find(user => user.accountUserId._id === this.props.editContent.reviewedby).accountUserId.firstName +" "+ this.props.reviewerList.find(user => user.accountUserId._id === this.props.editContent.reviewedby).accountUserId.lastName
                            : ""
                           }</strong>
                          </Grid.Column>
                           <Grid.Column width={5} style={{ wordBreak: "break-all" }}>
                            {/* <div dangerouslySetInnerHTML={{ __html: review.note }} /> */}
                        </Grid.Column>
                       </Grid.Row>
                          ) : null
                        }

                            <Grid.Row className="createPack "  >
                                <Grid.Column width={16}>
                                    {
                                        this.props.authorizeContent ||contentStatus==="approved"?
                                            <Labels
                                                name="Name"
                                                text={this.state.name}
                                            />
                                            :
                                            <Form.Input
                                                required
                                                name="name"
                                                id="name"
                                                label="Name"
                                                disabled={this.props.authorizeContent}
                                                validations={{ matchRegexp: singleLineText }}
                                                value={this.state.name}
                                                onChange={this.handleChange}
                                                errorLabel={errorLabel}
                                                validationErrors={{
                                                    matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                                    isDefaultRequiredValue: 'Name is required',
                                                }}
                                                instantValidation
                                                autoFocus
                                            />
                                    }
                                </Grid.Column>

                                <Grid.Column width={16}>
                                    {
                                        this.props.authorizeContent ||contentStatus==="approved" ?
                                           this.state.description!==""?
                                            <Labels name="Description"
                                              
                                                text={this.state.description}
                                                htmlView='true'
                                            />:""
                                            :
                                            <TextEditor
                                                name="Description"
                                                text={this.state.description}
                                                type="textarea"
                                                onChangeText={this.updateText}
                                            />
                                    }
                                </Grid.Column>
                            </Grid.Row>

                            <Grid.Row className="createPack" >
                                <Grid.Column width={5}>
                                    {
                                        this.props.authorizeContent ||contentStatus==="approved"?
                                            <Labels name="Type"
                                                text={this.state.type} />
                                            :
                                            <Form.Field
                                                placeholder='Type'
                                                label="Content Type"
                                                name='type'
                                                id='type'
                                                disabled={this.props.authorizeContent ||contentStatus==="approved"}
                                                onChange={this.handleChangeType}
                                                control='select'
                                                value={this.state.type}
                                                required
                                                errorLabel={errorLabel}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'Content Type is required',
                                                }}
                                                instantValidation
                                            >
                                                <option value='Type'>Content Type</option>
                                                <option value='Document'>Document</option>
                                                <option value='Audio'>Audio</option>
                                                <option value='Video'>Video</option>
                                                <option value='Image'>Image</option>
                                                <option value='Link'>Link</option>
                                                <option value='Tool'>Tool</option>
                                            </Form.Field>
                                    }
                                    {
                                        this.state.isContentTypeEmpty ?
                                            <span className="clr-red">
                                                Content type is required.
                                            </span> : null
                                    }
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    {
                                        this.props.authorizeContent ||contentStatus==="approved"?
                                            <Labels name="Content URL"
                                                text={this.state.contentpath}
                                                style={{ wordBreak: 'break-word' }} />
                                            :
                                            <Form.Input
                                                name="contentpath"
                                                id="contentpath"
                                                label="Content URL"
                                                required
                                                errorLabel={errorLabel}
                                                // validations="isUrl"
                                                validations={{ matchRegexp: urlValidation }}
                                                validationErrors={{
                                                    matchRegexp: 'Enter valid Content URL',
                                                    isDefaultRequiredValue: 'Content URL is required',
                                                }}
                                                instantValidation
                                                value={this.state.contentpath}
                                                onChange={this.handleChange}
                                                disabled={this.props.authorizeContent ||contentStatus==="approved"}
                                            />
                                    }
                                </Grid.Column>
                                <Grid.Column width={6}>
                                    {
                                        this.props.authorizeContent ||contentStatus==="approved" ?
                                            <Labels name="Content Author"
                                                text={this.state.contentAuthor} />
                                            :
                                            <Form.Input
                                                name="contentAuthor"
                                                id="contentAuthor"
                                                label="Content Author"
                                                errorLabel={errorLabel}
                                                validations={{ matchRegexp: singleLineText }}
                                                validationErrors={{
                                                    matchRegexp: 'Maximum character limit is 128.',
                                                }}
                                                instantValidation
                                                onChange={this.handleChangeAuthor}
                                                value={this.state.contentAuthor}
                                                disabled={this.props.authorizeContent ||contentStatus==="approved"}
                                            />
                                    }
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row className="createPack"  >
                                <Grid.Column width={16}>
                                    <label className='required-field f_11'>Publish Level </label>
                                    {(this.props.selectedOrganisation.publicLibraryAccess && this.props.selectedAccount.publicAccess && this.props.selectedOrganisation.role === 'workspaceOwner') ?
                                        (!this.props.editContent || (this.props.editContent && (this.props.editContent.scope === "Private" || ((!this.props.editContent.playbookActivitiesRef || (this.props.editContent.playbookActivitiesRef && this.props.editContent.playbookActivitiesRef.length === 0)) && (!this.props.editContent.initiativeActivitiesRef || (this.props.editContent.initiativeActivitiesRef && this.props.editContent.initiativeActivitiesRef.length === 0)))))) ?
                                            <Form.Field style={{ "marginTop": "12px", "marginLeft": "20px" }}>

                                                <b><Form.Radio
                                                    name='scope'
                                                    label='Workspace Library'
                                                    value='Private'
                                                    checked={isPrivate}
                                                    fluid
                                                    onChange={this.handleInputChange}
                                                    disabled={this.props.authorizeContent||contentStatus==="approved"}
                                                /></b>
                                                <div style={{ margin: '0px 0 10px 22px' }}>Content will appear under Workspace Library after it is published. All workspace level users can view this content.</div>
                                                <div style={{ margin: '0px 0 10px 22px' }}><Checkbox label='Account access i.e. read only access to all workspaces'  disabled={contentStatus==="approved"} checked={this.state.accountLevelAccess} onChange={this.setAccountLevelAccess}  /> </div>
                                                <div>
                                                    <b>
                                                        <Form.Radio
                                                            name='scope'
                                                            label='Public Library'
                                                            value='Public'
                                                            checked={!isPrivate}
                                                            onChange={this.handleInputChange}
                                                            disabled={this.props.authorizeContent||contentStatus==="approved"}
                                                        />
                                                    </b>
                                                    <div style={{ margin: '0px 0 10px 22px' }}>Content will appear under Public Library after it is published. All platform users can view this content.</div>
                                                </div>

                                            </Form.Field> :
                                            <div style={{ display: 'block' }}>
                                                <h3 style={{ margin: "10px 0 0px 22px" }}>
                                                    Public Library
                                                </h3>
                                                <div style={{ margin: '0px 0 10px 22px' }}>Content will appear under Public Library after it is published. All platform users can view this content.</div>
                                            </div> :
                                        ((!this.props.editContent || !this.props.editContent.scope) || (this.props.editContent && this.props.editContent.scope === 'Private')) ?
                                            <div style={{ display: 'block' }}>
                                                <h3 style={{ margin: "10px 0 0px 22px" }}>
                                                    Workspace Library
                                                </h3>
                                                <div style={{ margin: '0px 0 10px 22px' }}>Content will appear under Workspace Library after it is published. All workspace level users can view this content.</div>
                                                <div style={{ margin: '0px 0 10px 22px' }}><Checkbox label='Account access i.e. read only access to all workspaces' disabled={contentStatus==="approved"} checked={this.state.accountLevelAccess} onChange={this.setAccountLevelAccess}  /> </div>
                                            </div> :
                                            <div style={{ display: 'block' }}>
                                                <h3 style={{ margin: "10px 0 0px 22px" }}>
                                                    Public Library
                                                </h3>
                                                <div style={{ margin: '0px 0 10px 22px' }}>Content will appear under Public Library after it is published. All platform users can view this content.</div>
                                            </div>

                                    }
                                </Grid.Column>
                                <Grid.Column width={16} style={{ margin: "10px 0 5px 0" }}>
                                    <label className=' f_11'>Publish Category </label>

                                </Grid.Column>
                                <Grid.Column width={5} >
                                    {
                                        this.props.authorizeContent ||contentStatus==="approved"?
                                            <Labels name="Knowledge Bank "
                                                text={this.state.baseCategoryName} />
                                            :
                                            <div style={{ margin: "0 0 5px 0" }}>
                                                <label className='required-field'>Knowledge Bank </label>
                                                <Form.Field
                                                    id='baseCategory'
                                                    control='select'
                                                    name='baseCategory'
                                                    value={this.state.basecategoryid}
                                                    onChange={this.handleChangebaseCategory}
                                                    disabled={this.props.authorizeContent ||contentStatus==="approved"}
                                                >
                                                    <option value='select'>Select</option>
                                                    {bcA && bcA.map((baseCategory, index) => {
                                                        return (
                                                            <option value={baseCategory._id} key={index}>{baseCategory.name}</option>
                                                        );
                                                    }, this)}
                                                </Form.Field>
                                            </div>
                                    }
                                    {
                                        this.state.isKnowledgeBankEmpty ?
                                            <span className="clr-red">
                                                Knowledge Bank is required.
                                            </span> : null
                                    }
                                </Grid.Column>
                                <Grid.Column width={1}>
                                    {this.props.authorizeContent ||contentStatus==="approved"?
                                        <Icon name='angle right' color='grey' size="large" style={{ "paddingTop": "5px" }} /> :
                                        <Icon name='angle right' color='grey' size="large" style={{ "paddingTop": "30px" }} />
                                    }

                                </Grid.Column>
                                <Grid.Column width={5}>
                                    {
                                        this.props.authorizeContent ||contentStatus==="approved"?
                                            <Labels name="Category"
                                                text={this.state.categoryName} />
                                            :
                                            <div style={{ margin: "0 0 5px 0" }}>
                                                <label className='required-field'>Category </label>
                                                <Form.Field
                                                    id='category'
                                                    control='select'
                                                    name='category'
                                                    value={this.state.categoryid}
                                                    onChange={this.handleChangeCategory}
                                                    disabled={this.props.authorizeContent ? true : this.props.categoriesArr.length > 0 ? false : true||contentStatus==="approved"}
                                                >
                                                    <option value='select'>Select</option>
                                                    {cA && cA.map((categories, index) => {
                                                        return (
                                                            <option value={categories._id} key={index}>{categories.name}</option>
                                                        );
                                                    }, this)}
                                                </Form.Field>
                                            </div>
                                    }
                                    {
                                        this.state.isCategoryEmpty ?
                                            <span className="clr-red">
                                                Category is required.
                                            </span> : null
                                    }
                                </Grid.Column>
                                <Grid.Column width={1}>
                                    {this.props.authorizeContent ||contentStatus==="approved"?
                                        <Icon name='angle right' color='grey' size="large" style={{ "paddingTop": "5px" }} /> :
                                        <Icon name='angle right' color='grey' size="large" style={{ "paddingTop": "30px" }} />
                                    }
                                </Grid.Column>
                                <Grid.Column width={4}>
                                    {this.props.authorizeContent ||contentStatus==="approved"?
                                        <Labels name="Subcategory" text={this.state.subCategoryName} /> :
                                        ((this.props.subCategoriesArr.length >= 0 && ((this.props.editContent && this.props.editContent.subCategory && this.checkIndex(this.props.subCategoriesArr, this.props.editContent.subCategory) !== -1) || (this.props.editContent && (!this.props.editContent.subCategory || this.props.editContent.subCategory === "Select Sub Category")) || (!this.props.editContent || !this.props.editContent._id))) && this.state.otherSubCategory !== 'others') ?
                                            <div style={{ margin: "0 0 5px 0" }}>
                                                <label className='required-field'>Sub-Category </label>
                                                <Form.Field
                                                    id='subCategory'
                                                    control='select'
                                                    name='subCategory'
                                                    value={this.state.subCategory ? this.state.subCategory.toString() : ""}

                                                    onChange={this.handleChangeSubCategory}
                                                    disabled={this.props.authorizeContent || categoryId === 'select' ||this.state.category==="select"||!this.state.category||this.state.category==="Select Category"||contentStatus==="approved"}

                                                    validations={{ matchRegexp: singleLineText }}
                                                    errorLabel={errorLabel}
                                                    validationErrors={{
                                                        matchRegexp: 'Enter valid Sub-Category.',
                                                        isDefaultRequiredValue: 'Sub-Category is required',
                                                    }}
                                                    instantValidation
                                                >
                                                    <option value='Select Sub Category'>Select</option>
                                                    {scA && scA.map((categories, index) => {
                                                        return (
                                                            <option key={index} value={categories._id.toString()}>{categories.name}</option>
                                                        );
                                                    }, this)}
                                                    {isPrivate && <option value="others">Others</option>}
                                                </Form.Field></div> :
                                            <div style={{ margin: "0 0 15px 0" }}>

                                                {this.props.subCategoriesArr.length >= 0 && <Icon name='delete' onClick={this.setsubCategory} className="subcategoryOthers" />}

                                                <label className='required-field'>Sub-Category </label>
                                                <Form.Input
                                                    name="subCategory"
                                                    id="Subcategory"
                                                    value={this.state.subCategory !== 'others' ? this.state.subCategory : ''}
                                                    onChange={(data) => {
                                                        subCategory = data.target.value.trim();
                                                        this.setState({
                                                            'otherfield': data.target.value,
                                                            subCategory: data.target.value.trim()
                                                        })
                                                    }}
                                                    validations={{ matchRegexp: singleLineText }}
                                                    errorLabel={errorLabel}
                                                    validationErrors={{
                                                        matchRegexp: 'Enter valid Sub-Category.',
                                                        isDefaultRequiredValue: 'Sub-Category is required',
                                                    }}
                                                    instantValidation
                                                    disabled={this.props.authorizeContent || categoryId === 'select'||this.state.category==="select"||!this.state.category||this.state.category==="Select Category"}
                                                    placeholder="Select sub-category"
                                                />
                                            </div>
                                        // new

                                    }
                                    {
                                        this.state.isSubCategoryEmpty ?
                                            <span className="clr-red">
                                                Sub category is required.
                                            </span> : null
                                    }
                                </Grid.Column>

                                {this.state.categoryMsgFlag ?
                                    <Grid.Column width={16}>
                                        <span className="clr-red">Categories not available in selected knowledge bank. Please select another knowledge bank or contact your account owner.</span>
                                    </Grid.Column> : ''}

                            </Grid.Row>

                            {contentStatus !== "published" && contentStatus!=="approved" &&
                                (this.props.authorizeContent && this.props.editContent && contentStatus !== 'rejected' ?
                                    <Grid.Row className="createPack" style={{pointerEvents: contentStatus === 'approved' ? 'none' : 'auto'}} >
                                        <Grid.Column width={6}>
                                            <Form.Group width={12} grouped style={{ 'marginTop': '8px' }}>
                                                <label>Review </label>
                                                <Form.Group inline style={{ "marginTop": "12px" }}>
                                                    <Form.Radio
                                                        name='review'
                                                        label='Accept'
                                                        value='Accept'
                                                        checked={isAccepted}
                                                        onChange={this.handleAuthorization}
                                                    />
                                                    <Form.Radio
                                                        name='review'
                                                        label='Reject'
                                                        value='Reject'
                                                        checked={!isAccepted}
                                                        onChange={this.handleAuthorization}
                                                    />
                                                </Form.Group>
                                            </Form.Group>
                                        </Grid.Column>
                                        {
                                            !isAccepted ?
                                                <Grid.Column width={10}>
                                                    <div>
                                                        <label>Comments <span style={{ color: "red" }}>*</span></label>
                                                        <ReactQuill value={this.state.comments}
                                                            onChange={this.handleComment}
                                                            theme="snow"
                                                        />
                                                    </div>
                                                </Grid.Column>
                                                : ''
                                        }

                                    </Grid.Row>
                                    :
                                    <Grid.Row className="createPack" >
                                        <Grid.Column width={4}>
                                            <Checkbox style={{ 'paddingTop': '17px' }} label='Review required' onChange={this.reviewOptional} checked={this.state.reviewedby || reviewCheck} />
                                        </Grid.Column>
                                        <Grid.Column width={12}>
                                            {
                                                <div >
                                                    <Form.Field label='Select Review'
                                                        id='Reviewer'
                                                        control='select'
                                                        name='Reviewer'
                                                        disabled={!reviewCheck}
                                                        value={this.state.reviewedby}
                                                        onChange={this.handleChangeReviewer}
                                                    >
                                                        <option value=''>Select Reviewer</option>
                                                        {this.props.reviewerList && this.props.reviewerList && this.props.reviewerList.length > 0 &&
                                                            this.props.reviewerList.map(function (reviewer, index) {
                                                                if (reviewer.role !== 'Member' && reviewer.accountUserId._id.toString() !== this.props.user._id.toString()) {
                                                                    return (
                                                                        <option key={index} value={reviewer.accountUserId._id}>{reviewer.accountUserId.firstName} {reviewer.accountUserId.lastName} ({camelCaseCovert(reviewer.role)})</option>
                                                                    );
                                                                }
                                                            }, this)}
                                                    </Form.Field>
                                                </div>
                                            }
                                        </Grid.Column>
                                    </Grid.Row>)
                            }
                            {this.state.addContentError && this.state.addContentError.code === 409 &&
                                <Message
                                    color='yellow' className="inviteWarning"
                                    style={{ "display": "block" }}
                                    content="Content with same name already exists. Please rename the content."
                                />
                            }

                            {
                                this.props.editContent && contentStatus === 'rejected' ?
                                    <Grid.Row className="rowStyle createPack" style={{pointerEvents: contentStatus === 'approved' ? 'none' : 'auto',borderBottom: "1px solid #EEF1F3" }}  >
                                        <Grid.Column width={6}>
                                            <Icon
                                                style={{ fontSize: "8px", margin: "0 5px 0 0" }}
                                                circular
                                                className={this.props.editContent && contentStatus === 'rejected' ? "bg-orange" : "bg-green"}
                                                name={this.props.editContent && contentStatus === 'rejected' ? "close" : "checkmark"}
                                            />
                                            <span className={this.props.editContent && contentStatus === 'rejected' ? "clr-orange" : "clr-green"} >
                                                {this.props.editContent && contentStatus === 'rejected' ? "Rejected" : "Approved"}
                                            </span>
                                            &nbsp;&nbsp;&nbsp;
                                    by  <strong>{ reviewerName||this.props.editContent && this.props.editContent.reviewedbyObj && this.props.editContent.reviewedbyObj.firstName + ' ' + this.props.editContent.reviewedbyObj.lastName}</strong>
                                        </Grid.Column>
                                        <Grid.Column width={10} style={{ "word-break": "break-all" }}>
                                            <div dangerouslySetInnerHTML={{ __html: this.props.editContent && this.props.editContent.comments }} />
                                        </Grid.Column>
                                    </Grid.Row>
                                    : ''
                            }

                            {
                                (this.props.editContent && contentStatus === 'under_review' && this.props.editContent.reviewedby === this.props.user._id) || (this.props.contentStatus === 'forreview' && this.props.editContent.reviewedby === this.props.user._id) ?
                                    <Grid.Row>
                                        <Grid.Column width={16} floated="right" className="text-right">
                                            {/* <Button disabled={!isAccepted || (!this.props.selectedAccount.publicAccess && !isPrivate)} floated='right' id='submitBtn' className="button-submit" onClick={this.handleSubmit}>Publish</Button> */}
                                            <Button  disabled={!isAccepted} floated='right' id='submitBtnPbl' className="button-submit" onClick={this.approve}>Approve</Button>
                                            <Button disabled={isAccepted || !this.state.comments} floated='right' id='rejectBtnPbl' className="button-info" onClick={this.handleSubmit}>Submit for Corrections</Button>
                                            <Button floated='right' className="button-cancel" id='cancelBtnPbl' onClick={(e) => this.handleCancel(e)}>Cancel</Button>
                                        </Grid.Column>
                                    </Grid.Row>
                                    :
                                    <Grid.Row className="actionInFormcy border-none">
                                        {
                                            (this.props.editContent && contentStatus === 'rejected') || reviewCheck ?
                                                <Grid.Column width={16} >
                                                  {!reviewCheck && <Button id='submitBtnPbl12' type='button' disabled={(!this.props.selectedAccount.publicAccess && !isPrivate)} className="button-submit float-right" onClick={this.publishContent}>Publish</Button>}
                                                    {!reviewCheck && <Button disabled={(this.state.status !== 'in_development') || (this.state.reviewedby)} id='submitBtnSave' className="button-submit-2 float-right" type="submit" name='draft'>Save Draft</Button>}
                                                    {reviewCheck && <Button disabled={!this.state.reviewedby  || (!this.props.selectedAccount.publicAccess && !isPrivate)} type='button' onClick={() => this.submitforreview('ab')} id='submitBtnReview' className="button-submit float-right" >Submit for Review</Button>}
                                                    <Button id='cancelBtn' className="button-cancel" onClick={(e) => this.handleCancel(e)} type='button'>Cancel</Button>
                                                </Grid.Column> :
                                                <Grid.Column width={16} >
                                                    <Button id='submitBtnPbl12' type='button' disabled={(!this.props.selectedAccount.publicAccess && !isPrivate)} className="button-submit float-right" onClick={this.publishContent}>Publish</Button>
                                                    {contentStatus !== "published" && contentStatus!=="approved" && <Button disabled={(this.state.status !== 'in_development') || (this.state.reviewedby)} id='submitBtnSave' className="button-submit-2 float-right" type="submit" name='draft'>Save Draft</Button>}
                                                    <Button id='cancelBtn' className="button-cancel " onClick={(e) => this.handleCancel(e)} type='button'>Cancel</Button>
                                                </Grid.Column>
                                        }
                                    </Grid.Row>
                            }

                        </Grid>
                    </Form>



                </div>
                {this.props.editContent && <Modal
                    open={this.props.editContent.throwOut}
                    className="basicModal"
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                >
                    <Modal.Header >Publish Publicly Access Revoked</Modal.Header>
                    <Modal.Content>
                        <p>Your Access to Publish Publicly has been revoked, Please access the content again.</p>
                        <div className="pull-right" style={{ "marginBottom": "25px" }}>
                            <Button
                                type="submit"
                                id='addbtn'
                                content='Ok'
                                onClick={this.throwOut}
                                className="button-submit" />
                        </div>
                    </Modal.Content>
                </Modal>}
            </div >
        )
    }
}

export default withRouter(AddContent);

